import React from 'react';
import './Resources.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Resources = () => {
  const sectionRef = useScrollAnimation();

  const resources = [
    {
      name: 'Canada Revenue Agency',
      url: 'https://www.canada.ca/en/revenue-agency.html',
      description: 'Official CRA website for tax information and services'
    },
    {
      name: 'Health and safety compliance',
      url: 'https://www.ontario.ca/page/occupational-health-and-safety-compliance',
      description: 'Ontario workplace health and safety compliance information'
    },
    {
      name: 'Understanding Your CRA Rights',
      url: 'https://www.cfib-fcei.ca/en/tools-resources/canada-revenue-agency-your-rights-business-owner',
      description: 'Understanding your rights as a business owner with CRA'
    },
    {
      name: 'Registered Retirement Savings Plan',
      url: 'https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/rrsps-related-plans/registered-retirement-savings-plan-rrsp.html',
      description: 'RRSP information and contribution guidelines'
    },
    {
      name: 'Old Age Security',
      url: 'https://www.canada.ca/en/services/benefits/publicpensions/old-age-security.html',
      description: 'OAS pension eligibility and application information'
    },
    {
      name: 'Employment Insurance benefits',
      url: 'https://www.canada.ca/en/services/benefits/ei.html',
      description: 'EI benefits and eligibility requirements'
    },
    {
      name: 'Canada Pension Plan',
      url: 'https://www.canada.ca/en/services/benefits/publicpensions/cpp.html',
      description: 'CPP benefits and contribution information'
    },
    {
      name: 'Disability Tax Credit',
      url: 'https://www.canada.ca/en/revenue-agency/services/tax/individuals/segments/tax-credits-deductions-persons-disabilities/disability-tax-credit.html',
      description: 'DTC application and eligibility information'
    },
    {
      name: 'Corporations Canada',
      url: 'https://ised-isde.canada.ca/site/corporations-canada/en',
      description: 'Federal corporation registration and management'
    },
    {
      name: 'Payroll Deduction online Calculator',
      url: 'https://www.canada.ca/en/revenue-agency/services/e-services/digital-services-businesses/payroll-deductions-online-calculator.html',
      description: 'Calculate payroll deductions and remittances'
    },
    {
      name: 'GST/HST Credit Calculator',
      url: 'https://www.canada.ca/en/revenue-agency/services/child-family-benefits/goods-services-tax-harmonized-sales-tax-gst-hst-credit.html',
      description: 'Calculate GST/HST credit amounts'
    }
  ];

  return (
    <section className="resources section fade-in-up" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Resources</h2>
          <p className="section-subtitle">Useful Links</p>
        </div>

        <div className="resources-grid">
          {resources.map((resource, index) => (
            <div key={index} className="resource-card">
              <div className="resource-icon">⭐</div>
              <div className="resource-content">
                <h3 className="resource-title">
                  {resource.url !== '#' ? (
                    <a 
                      href={resource.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="resource-link"
                    >
                      {resource.name}
                    </a>
                  ) : (
                    <span className="resource-link-disabled">{resource.name}</span>
                  )}
                </h3>
                <p className="resource-description">{resource.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Resources;
